// Shared capability text match for every capability search box (Devices
// filter, add-constraint picker, device Capabilities filter), so they all find
// the same things. Matches name, label and description, case-insensitive;
// every whitespace-separated term must appear somewhere ("solar charge").
export function capabilityMatches(capability, query) {
  const terms = query.trim().toLowerCase().split(/\s+/).filter(Boolean)
  if (terms.length === 0) return true
  const haystack = [capability.name, capability.label, capability.description]
    .filter(Boolean)
    .join(' ')
    .toLowerCase()
  return terms.every(t => haystack.includes(t))
}
